import React, { JSX, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import { useRazorpay } from "react-razorpay";
import { useAuth } from "../../context/AuthContext";
import { useJobSeeker } from "../../context/JobSeekerContext";
import { InitPaymentResponse, PaymentDetailsResponse } from "../../types/api";

const Payment: React.FC = () => {
  const { error, isLoading: razorpayCheckoutLoading, Razorpay } = useRazorpay();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [serverError, setServerError] = useState<string | null>(null);
  const [paymentId, setPaymentId] = useState<string | null>(null);
  const { startOnboardingPayment, getJobSeekerPaymentDetails, isOnboardingPaymentDone } = useJobSeeker();

  const { user } = useAuth();
  const navigate = useNavigate();
  // useEffect(()=>{
  //   setIsLoading(razorpayCheckoutLoading)
  // },[razorpayCheckoutLoading])
  // Placeholder: simulate redirect to external gateway and back
  const handleSimulatePayment = () => {
    try {
      if (isLoading) return;
      setIsLoading(true);

      startOnboardingPayment(paymentId || "").then(async (resp) => {
        if (resp && resp.payload && resp.payload.checkoutReqDetails ) {
          setPaymentId(resp.payload?.payment_id)
          const options: any = {
            ...resp.payload.checkoutReqDetails,
            handler: async function (response: any) {
              setIsLoading(false);
              const paymentDetails: PaymentDetailsResponse | undefined = await getJobSeekerPaymentDetails(resp.payload?.payment_id || "");
              if (paymentDetails && paymentDetails.paymentStatus === "Paid") {
                resp.successCallback()
                navigate("/user/payment/success");
              } else {
                setServerError(
                  "Transaction is in " + (paymentDetails?.paymentStatus || "unknown") + " state"
                );
              }
            },
          };

          const rzp = new Razorpay(options);
          rzp.open();
          console.log("After razorpay open");
          setIsLoading(razorpayCheckoutLoading);
        } else {
          setServerError("Failed to get payment initiation details.");
          setIsLoading(false);
        }
      }).catch((err: any) => {
        console.error("Error in handle payment >>>", err);
        setServerError(err.message || "An error occurred during payment initiation.");
        setIsLoading(false);
      });
    } catch (error) {
      console.log("Error in handle payment >>>", error);
    }
  };
  interface ErrorMessageProps {
    errorText: string;
  }
  const ErrorBlock: React.FC<ErrorMessageProps> = ({ errorText }) => {
    return (
      <p className="my-2 text-sm text-red-600 flex items-center">
        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        {errorText}
      </p>
    );
  };
  return (
    <>
      <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
      <div className="max-w-2xl mx-auto p-6">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment</h1>
          <p className="text-gray-600 mb-6">
            You will be redirected to a secure payment gateway to complete your
            purchase.
          </p>
          <Button disabled={isOnboardingPaymentDone && user?.role != 'Intern'} onClick={handleSimulatePayment} loading={isLoading}>
            {(isOnboardingPaymentDone && user?.role != 'Intern') ? "Payment Already Completed" : "Complete Payment"}
          </Button>
          {error && <ErrorBlock errorText={error} />}
          {serverError && <ErrorBlock errorText={serverError} />}
        </div>
      </div>
    </>
  );
};

export default Payment;
